import { GridApi, GridOptions, IServerSideGetRowsParams, IToolPanelParams, ModuleRegistry, RowNode } from "@ag-grid-community/core";
import { Component, OnDestroy } from "@angular/core";
import { ServerSideRowModelModule } from "@ag-grid-enterprise/server-side-row-model";
import { CurrencyPipe } from "@angular/common";
import { PlanyardService } from 'src/app/modules/planyard/planyard.service';
import { PurchasingService } from "src/app/modules/planyard/purchasing.service";
import { HumanizeDatePipe } from "src/app/pipes/humanize-date.pipe";
import { Subject, takeUntil } from "rxjs";

ModuleRegistry.registerModules([
  ServerSideRowModelModule,
]);

@Component({
  selector: "app-sku-breakdown-panel",
  templateUrl: "./sku-breakdown-panel.component.html",
  styleUrls: ["./sku-breakdown-panel.component.scss", "../panel.scss"],
  providers: [HumanizeDatePipe],
})
export class SkuBreakdownPanelComponent implements OnDestroy {
  params: IToolPanelParams;
  sku: any;
  breakdown: any;
  demandTotal: number;
  suggestionTotal: number;
  private destroy$ = new Subject<void>();

  salesColumnDef = [
    {
      field: "Purchased",
      headerName: "Date",
      width: 120,
      valueFormatter: (params) => this.humanizeDatePipe.transform(params.value, 'MM/dd/yyyy h:mm a'),
    },
    {
      headerName: 'Order Id',
      field: "Orderid",
      width: 110,
    },
    
    {
      field: "Qty",
      width: 50,
      valueGetter: (params) => {
        return (Number(params.data.Qty) || 0).toLocaleString('en');
      },
    },
    {
      field: "Price",
      headerName: "Total Price",
      width: 70,
      valueFormatter: (params) => this.currencyPipe.transform(params.value),
    },
    {
      field: "FulfillmentType",
      headerName: "Fulfillment",
      width: 75,
    }
  ];
  salesGridApi: GridApi;
  salesGridOptions: GridOptions = {
    onGridReady: (params) => {
      this.salesGridApi = params.api;
    },
    defaultColDef:{
     sortable:false
    },
    serverSideDatasource: {
      getRows: (params: IServerSideGetRowsParams) => {
        params.request.filterModel['Asin'] = {
          filter: this.sku.Asin,
          filterType: "text",
          type: "equals",
        };
        this.planyardService
        .GetOrdesrList(params.request, [], null,this.sku.Account)
        .pipe(takeUntil(this.destroy$)).subscribe({
          next: (response: any) => {
            if (response) {
              if (!response.totalCount) {
                this.salesGridApi.showNoRowsOverlay();
              } else {
                this.salesGridApi.hideOverlay();
              }
              params.success({
                rowData: response.data,
                rowCount: response.totalCount,
              });
            }
          },
         error: (err) => {
          params.fail()
         }
       });
      },
    },
    columnDefs: this.salesColumnDef,
    rowModelType: "serverSide",
    suppressServerSideInfiniteScroll: false,
  };

  stockGridOptions: GridOptions = {
    ...this.salesGridOptions,
    columnDefs: [
      {
        field: "Date",
      },
      {
        field: "Stock",
      },
      {
        field: "FBA Stock",
      },
      {
        field: "FBA Sales",
      },
      {
        field: "Pushed",
      }
    ]
  };
  constructor(
    private purchasingService: PurchasingService,
    private planyardService: PlanyardService,
    private currencyPipe: CurrencyPipe,
    private humanizeDatePipe: HumanizeDatePipe
  ) { }

  agInit(params: IToolPanelParams): void {
    this.params = params;
  }

  refresh(): void {
    this.sku = this.purchasingService.selectedSidePanelSku;
    this.loadBreakdownInfo();
    this.resetGrids();
  }

  loadBreakdownInfo() {
    if (this.sku) {     
      this.demandTotal = this.sku.Suggested || this.sku.SelectedQty || 0;
      this.suggestionTotal = this.demandTotal - this.sku.TotalFbastock;
    }
  }

  resetGrids() {
    if (this.salesGridApi) {
      this.salesGridApi.refreshServerSide({ route: [], purge: true });
    }

  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
